import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "error", "errorContainer"];

  static values = {
    errorMessage: String,
  };

  declare checkboxTarget: HTMLInputElement;
  declare errorTarget: HTMLElement;
  declare errorMessageValue: string;

  connect() {
    this.bindMethods();
    this.element.addEventListener("submit", this.onSubmit);
  }

  bindMethods() {
    this.onSubmit = this.onSubmit.bind(this);
  }

  disconnect() {
    this.element.removeEventListener("submit", this.onSubmit);
  }

  onSubmit(e: Event) {
    if (!this.isChecked()) {
      e.preventDefault();
      e.stopPropagation();
      this.renderError();
      return;
    }
  }

  isChecked() {
    return this.checkboxTarget.checked;
  }

  renderError() {
    this.errorTarget.textContent = this.errorMessageValue;
  }
}
